<template>
  <v-container></v-container>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['code', 'state', 'session_state','error_description'],
    computed: {
      authenticated () {
        return this.$store.getters.authenticated
      }
    },
    mounted () {
      if (!this.authenticated|| !this.$store.state.user.signicatAuthenticated) {
        this.authenticateUser()
      } else {
        this.$router.push('/')
      }
    },
    methods: {
      authenticateUser () {
        var loginType=0
        if(this.authenticated)
          loginType=6

        var userData = {
          LoginType: loginType,
          code: `${this.code}`,
          state: `${this.state}`,
          session_state: `${this.session_state}`,
          redirectTo: '/',
          error_description: `${this.error_description}`
        }
        if (!this.$store.getters.loading&& !this.$store.state.user.signicatAuthenticated) { 
          this.$store.commit('setLoading', true)
          this.$store.commit('setInitializing', true)
          this.$store.commit('clearError')

          apiResource.post('api/authentication/confirm', userData).then((response) => {
            this.$store.dispatch('authenticateUser', userData)
            this.$store.commit('setsignicatAuthenticated', true)
          }).catch((errorResponse) => {
            console.log('tupas error', errorResponse)
            this.$store.commit('setsignicatAuthenticated', false)
            if(errorResponse.response && errorResponse.response.data === 'Cancel')
            {
              this.$store.commit('setMessage', { type: 'info', text: 'error.login.2', translate: true })
            }else if(errorResponse.response && errorResponse.response.data === 'NoDebts')
            {
              this.$store.commit('setMessage', { type: 'info', text: 'error.login.4', translate: true })
            }else
            {
              this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
            }
            this.$store.commit('setLoading', false)
            this.$store.commit('setInitializing', false)
            this.$router.push('/')
          })
        }
      }
    }
  }
</script>
